import { NavLink } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen pt-16 flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-4xl text-foreground-600"></i>
        </div>
        <h1 className="mt-6 text-3xl font-heading font-semibold text-foreground-950">404</h1>
        <p className="mt-2 text-sm text-foreground-600">抱歉，您访问的页面不存在</p>
        <NavLink
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </NavLink>
      </div>
    </div>
  );
}